import { render, staticRenderFns } from "./HeaderDetailItemSR.vue?vue&type=template&id=6a1bb673"
import script from "./HeaderDetailItemSR.vue?vue&type=script&lang=js"
export * from "./HeaderDetailItemSR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports